import { createPinia } from 'pinia';
import { createApp } from 'vue';

import './styles/index.scss';
import config from '@/config';
import App from './App.vue';
import { i18n } from './i18n';
import directives from './setup/directives';
import gtag from './setup/plugins/gtag';
import mixpanel from './setup/plugins/mixpanel';
import './setup/datadog';
import VueTelInput from 'vue-tel-input';
import widgetSettings from './widget-settings';

import { useCompanyStore } from './stores/company';

const app = createApp(App);
app.use(createPinia());
app.use(i18n);
app.use(mixpanel, {
  token: config.MIXPANEL_TOKEN
});
app.use(VueTelInput);

Object.keys(directives).forEach((key) => {
  app.directive(key, directives[key]);
});

const { fetchCompany } = useCompanyStore();
fetchCompany(widgetSettings.company).then(() => {
  const { company } = useCompanyStore();
  app.use(gtag, {
    disabled: !!widgetSettings.bookingId,
    gaId: company.settings.ga_id
  });
  app.mount('#app');
});
